import './left-navigation.scss';

import { Collapse, Paper } from '@mui/material';
import React, { useEffect, useState } from 'react';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { NavigationItem } from '@converge/graphql';
import { capitalizeWordsExceptPreposition } from '@converge/utils';

export interface ILeftNavigationProp {
  items: NavigationItem[];
  selectedItem: NavigationItem | null;
  onItemSelected(item: NavigationItem): void;
  selectedSubItem?: NavigationItem | null;
  onSubItemSelected?(item: NavigationItem, parentItem: NavigationItem): void;
}

export const LeftNavigation = ({
  items,
  selectedItem,
  onItemSelected,
  selectedSubItem,
  onSubItemSelected,
}: ILeftNavigationProp) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(selectedSubItem ? true : false);
  }, [selectedSubItem]);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    section: NavigationItem
  ) => {
    onItemSelected(section);
    if (section.subItems) {
      setOpen(!open);
    } else {
      setOpen(false);
    }
  };

  const handleSubListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    section: NavigationItem,
    parentSection: NavigationItem
  ) => {
    onSubItemSelected && onSubItemSelected(section, parentSection);
  };

  return (
    <Paper className="left-navigation" elevation={0}>
      <List component="nav" aria-label="application menus">
        {items.map((currentItem) => {
          return (
            <div key={currentItem.value}>
              <ListItemButton
                disabled={currentItem.disabled}
                selected={
                  (selectedItem && selectedItem.value === currentItem.value) ??
                  false
                }
                onClick={(event) => handleListItemClick(event, currentItem)}
              >
                <ListItemText primary={currentItem.label} />
              </ListItemButton>
              {currentItem.subItems && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <List
                    component="nav"
                    disablePadding
                    aria-label="questions section"
                    className="left-sub-navigation"
                  >
                    {currentItem.subItems?.map((subItem) => {
                      return (
                        <ListItemButton
                          className="nested-list"
                          key={subItem.value}
                          selected={
                            (selectedSubItem &&
                              selectedSubItem.value === subItem.value) ??
                            false
                          }
                          onClick={(event) => {
                            handleSubListItemClick(event, subItem, currentItem);
                          }}
                        >
                          <ListItemText
                            primary={capitalizeWordsExceptPreposition(
                              subItem.label
                            )}
                          />
                        </ListItemButton>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </div>
          );
        })}
      </List>
    </Paper>
  );
};
